import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const MonitorIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <span role="img" aria-label="monitor" className="anticon">
      <svg
        viewBox="0 0 18 19"
        focusable="false"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        {...rest}
      >
        <path
          d="M14.625 3.2124H3.375C2.92745 3.2124 2.49822 3.39019 2.18176 3.70666C1.86529 4.02313 1.6875 4.45235 1.6875 4.8999V12.7749C1.6875 13.2225 1.86529 13.6517 2.18176 13.9681C2.49822 14.2846 2.92745 14.4624 3.375 14.4624H14.625C15.0726 14.4624 15.5018 14.2846 15.8182 13.9681C16.1347 13.6517 16.3125 13.2225 16.3125 12.7749V4.8999C16.3125 4.45235 16.1347 4.02313 15.8182 3.70666C15.5018 3.39019 15.0726 3.2124 14.625 3.2124ZM15.1875 12.7749C15.1875 12.9241 15.1282 13.0672 15.0227 13.1727C14.9173 13.2781 14.7742 13.3374 14.625 13.3374H3.375C3.22582 13.3374 3.08274 13.2781 2.97725 13.1727C2.87176 13.0672 2.8125 12.9241 2.8125 12.7749V4.8999C2.8125 4.75072 2.87176 4.60764 2.97725 4.50215C3.08274 4.39667 3.22582 4.3374 3.375 4.3374H14.625C14.7742 4.3374 14.9173 4.39667 15.0227 4.50215C15.1282 4.60764 15.1875 4.75072 15.1875 4.8999V12.7749ZM11.8125 16.1499C11.8125 16.2991 11.7532 16.4422 11.6477 16.5477C11.5423 16.6531 11.3992 16.7124 11.25 16.7124H6.75C6.60082 16.7124 6.45774 16.6531 6.35225 16.5477C6.24676 16.4422 6.1875 16.2991 6.1875 16.1499C6.1875 16.0007 6.24676 15.8576 6.35225 15.7522C6.45774 15.6467 6.60082 15.5874 6.75 15.5874H11.25C11.3992 15.5874 11.5423 15.6467 11.6477 15.7522C11.7532 15.8576 11.8125 16.0007 11.8125 16.1499Z"
          fill={color ?? token.colorPrimary}
        />
      </svg>
    </span>
  );
};

export default MonitorIcon;
